export const SUB_LABEL_MAX = 48;
export const SUB_LABEL_SHOW = 28;

export function clipLabel(label: string): string {
  return label.length <= SUB_LABEL_SHOW ? label : `${label.slice(0, SUB_LABEL_SHOW)}…`;
}

export function resolveSubscriptionLabel(
  label: string | null | undefined,
  index: number,
  defaultName: (n: number) => string,
): string {
  const trimmed = label?.trim();
  return trimmed && trimmed.length > 0 ? trimmed : defaultName(index + 1);
}
